@if (flagsCount() > 0) {
  <section>
    <h3 class="mb-2">SMART CLAIM Decisioning System</h3>
    <div class="card mb-3">
      <div class="card-body d-flex flex-column gap-3">
        <div class="d-flex">
          <div class="smartClaimSummary">
            <div class="d-flex justify-content-between" data-testid="smart-claim-summary-scan">
              <div>Scan Record ID:</div>
              <div class="text-end">{{ scanId() }}</div>
            </div>
            <div class="d-flex justify-content-between" data-testid="smart-claim-summary-items">
              <div>Items Scanned:</div>
              <div class="text-end">{{ flagsScanned() }}</div>
            </div>
            <div class="d-flex justify-content-between" data-testid="smart-claim-summary-detections">
              <div>Detections:</div>
              <div class="text-end">{{ flagsCount() }}</div>
            </div>
          </div>
          <div class="scanVerticalSeparator"></div>
          <div class="scanStatus flex-grow-1 bg-success text-white d-flex align-items-center gap-3 px-3 py-2">
            <div class="flex-grow-1 d-flex align-items-center gap-2">
              <chitin-icon icon="fa-solid fa-circle-info" style="font-size: var(--fs-2xl)" />
              <div>Action taken</div>
            </div>
            <div class="flex-grow-1 fw-bold">{{ flagsIdentity() }}</div>
            <div class="scanStatusDivider"></div>
            @if (economicValue()) {
              <div class="text-end" style="flex-grow: 0.5" [ngbPopover]="flagsValueDescription()" placement="top-right" triggers="hover">
                <div class="fw-bold">
                  {{ economicValue() | currency }}
                </div>
                <div style="font-size: var(--fs-xs); margin-top: var(--space-x-n6px)">value</div>
              </div>
            } @else {
              <div style="width: 35%"></div>
            }
          </div>
        </div>

        <div class="d-flex flex-column gap-2">
          @for (item of flagsCategoriesFiltered(); track $index) {
            @let itemFlags = flagsMapFiltered()[item.title];
            @let itemCount = itemFlags?.length ?? 0;
            <chitin-accordion
              class="flagCategoryAccordion"
              style="--flag-flair-color: {{ item.color }}"
              [titleIcon]="itemCount > 0 ? 'fa-solid fa-circle-exclamation' : undefined"
              titleIconColor="pink"
              [title]="item.title"
              [titleEnd]="itemCount.toString()"
              [isOpen]="true"
            >
              @for (flag of itemFlags; track $index; let last = $last) {
                <div class="pb-1" style="flex-grow: 1">
                  <div class="text-black" style="font-weight: 500" data-testid="claimFlagTitle">{{ flag.title }}</div>
                  @if (flag.description) {
                    <div class="text-black" style="font-size: var(--fs-md); line-height: 1rem" data-testid="claimFlagDescription">
                      {{ flag.description }}
                    </div>
                  }
                </div>

                @if (!last) {
                  <div class="scanHorizontalSeparator my-3"></div>
                }
              }
            </chitin-accordion>
          }
        </div>
      </div>
    </div>
  </section>
}
